"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_POLYGON_PROTECTION_AREA_THRESHOLD = exports.DEFAULT_VIA_HOLE_SIZE = exports.DEFAULT_VIA_SIZE = exports.DEFAULT_THROUGH_HOLE_VIA_UID = exports.DEFAULT_LAYOUT_STACKUP_KEY = exports.DEFAULT_FOOTPRINT_STACKUP_KEY = void 0;
exports.DEFAULT_FOOTPRINT_STACKUP_KEY = "footprint-2-layer";
exports.DEFAULT_LAYOUT_STACKUP_KEY = "standard-4-layer";
exports.DEFAULT_THROUGH_HOLE_VIA_UID = "throughHole";
// Extracted these values out of `DefaultRuleSheet` so they can be used
// in `./stackup.ts` as well, and thus avoid circular dependencies.
exports.DEFAULT_VIA_SIZE = "0.6mm";
exports.DEFAULT_VIA_HOLE_SIZE = "0.3mm";
exports.DEFAULT_POLYGON_PROTECTION_AREA_THRESHOLD = 0.1; // 10% of the total layout area
//# sourceMappingURL=constants.js.map